import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { TIER_UPGRADE_FIELDS } from 'src/constants/billAutomation';
import { useStore } from 'src/stores';
import { getCurrentCompanyId } from 'src/stores/billAutomation/currentCompanyId';
import { upgradeRequested } from 'src/stores/company/upgradeRequests';
import { isLivableStaffFromToken } from 'src/utils/isLivableStaffFromToken';
import { tierOf } from './tiers';
import { UpgradeDialog } from './UpgradeDialog';
import useStyles from './styles';

/**
 * "Upgrade now" beside a plan lock (LB-6187, PRD V3 FR-5), for the company on screen: it opens the terms, then files
 * the request. Once this company has asked for the plan (or a higher one) it reads "Upgrade requested". Livable staff
 * can't buy for a customer, so they're told what the customer sees instead.
 *
 * `where` names the screen in the request, e.g. "setup editor".
 */
export const UpgradeNow = observer(_ref => {
  var _store$homeDashboardS;
  let tier = _ref.tier,
    where = _ref.where,
    className = _ref.className;
  const classes = useStyles();
  const store = useStore();
  // Observed, so a company switch re-renders; the company itself is localStorage's, which the switch writes first.
  const companyAccessId = (_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.companyAccessId;
  const companyId = companyAccessId ? getCurrentCompanyId() : '';
  // Open for one company only: a switch closes it rather than showing it for the next company, or again on the way back.
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    openFor = _useState2[0],
    setOpenFor = _useState2[1];
  useEffect(() => setOpenFor(''), [companyId]);

  // Only a plan the request form can ask for: nobody upgrades to Pro.
  const entry = Object.prototype.hasOwnProperty.call(TIER_UPGRADE_FIELDS, tier) ? tierOf(tier) : null;
  if (!entry || !companyId) return null;
  const noteClass = className ? "".concat(classes.upgradeNote, " ").concat(className) : classes.upgradeNote;
  if (isLivableStaffFromToken()) return /*#__PURE__*/React.createElement("span", {
    className: noteClass
  }, "Customers see Upgrade now");
  return /*#__PURE__*/React.createElement(React.Fragment, null, upgradeRequested(companyId, entry.name) ? /*#__PURE__*/React.createElement("span", {
    className: noteClass
  }, "Upgrade requested") : /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "text",
    className: className ? "".concat(classes.upgradeButton, " ").concat(className) : classes.upgradeButton,
    onClick: () => setOpenFor(companyId)
  }, "Upgrade now"), /*#__PURE__*/React.createElement(UpgradeDialog, {
    key: companyId,
    tier: entry.name,
    where: where,
    companyId: companyId,
    open: openFor === companyId,
    onClose: () => setOpenFor('')
  }));
});